/** @format */

import React from "react";

const Header = ({ title }) => {
    return (
        <div className="">
            <h4 className="font-bold uppercase p-5 text-[16px]">{title}</h4>
            <div className="w-full h-[1px] bg-[#ECECEC]" />
        </div>
    );
};
export default Header;
